import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  workValue: string
}

export class ChangeWorkValueWriteRequest extends WriteRequest<void> {
  private readonly endpoint: string =
    "/user_profile/user/edit/work_value/change"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    return this.apiClient.post(this.endpoint, this.params)
  }
}
